import Vue from "vue";
import firebase from 'firebase'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "./assets/scss/styles.scss";
// Layouts

Vue.config.productionTip = false;

const config = {
  apiKey: "AIzaSyD4WIXm7nhELRLQuHZB0GFAFEjRqGzkr9g",
  authDomain: "reply-ninja.firebaseapp.com",
  databaseURL: "https://reply-ninja.firebaseio.com",
  projectId: "reply-ninja",
  storageBucket: "reply-ninja.appspot.com",
  messagingSenderId: "481701534991",
  appId: "1:481701534991:web:f617b39a0ddd23e3"
};

firebase.initializeApp(config);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
